import React from 'react'
import FieldProto from "../../../../../../fields3/proto/field-proto"

type Props = {
    field       : FieldProto

    selected    : boolean
    hasIcons    : boolean
    disabled?   : boolean

    onClick     : {(fieldId: ID): void}
}

export default function FieldItemDefault(props:Props) {

    const onClick = () => {
        if (props.disabled) return;
        props.onClick(props.field.fieldId)
    }

    return (
        <div className={Classes("option", {selected: props.selected, disabled: props.disabled})} onClick={onClick}>
            {props.hasIcons && <div className={Classes('ico', props.field?.icon)} />}
            <div className="label">{props.field.label}</div>
        </div>
    )
}